export * from '@sayyoo/services-house';



//////////////////
// WEBPACK FOOTER
// ./~/@sayyoo/services-http-apis/lib/house.js
// module id = zhev
// module chunks = 256